import axios from "../axios";

export default {
  namespaced: true,
  state: {
    bike_damage_definitions: [],
    loading: false,
    error: null
  },
  mutations: {
    RESET_ERROR(state) {
      state.error = null;
    },
    GET_BIKE_DAMAGES_DEFINITIONS_REQUEST(state) {
      state.loading = true;
      state.error = null;
    },
    GET_BIKE_DAMAGES_DEFINITIONS_SUCCESS(state, data) {
      state.loading = false;
      state.error = null;
      state.bike_damage_definitions = data;
    },
    GET_BIKE_DAMAGES_DEFINITIONS_FAILURE(state, error) {
      state.loading = false;
      state.error = error;
      state.bike_damage_definitions = [];
    },
    ERROR_STATUS(state, error) {
      state.error = Object.entries(error).reduce((accu, [key, value]) => {
        accu = accu + `${key} ${value}`;
        return accu;
      }, "");
    }
  },
  actions: {
    getAllBikeDamageDefinitions: async ({ commit }) => {
      try {
        commit("GET_BIKE_DAMAGES_DEFINITIONS_REQUEST");
        const { data } = await axios.get(`/type-definitions/bike-damages`);
        commit("GET_BIKE_DAMAGES_DEFINITIONS_SUCCESS", data);
      } catch (err) {
        commit("GET_BIKE_DAMAGES_DEFINITIONS_FAILURE", err);
      }
    }
  }
};
